<template>
	<div>
		<ProfileSelector
			:serviceId="appId"
			:serviceVersionId="appVersionId"
			v-bind="$attrs"
			v-on="$listeners"
			:selectedProjectId="selectedProjectId"
		/>
		<div v-if="showWrongServiceWorkspaceMessage" class="wrong-account-msg pt-3">
			<h3 class="reg">Seems like this isn't the right account. Please connect the account you're logged into on this page.</h3>
		</div>
	</div>
</template>

<script>
import ProfileSelector from '@/components/common/ProfileSelector/ProfileSelector.vue';
export default {
	name: 'ChooseCredentialsProfileSelector',
	props: {
		appId: { type: Number },
		appVersionId: { type: String },
		selectedProjectId: { type: Number },
		showWrongServiceWorkspaceMessage: { type: Boolean },
	},
	components: { ProfileSelector },
};
</script>

<style lang="scss" scoped>
.wrong-account-msg {
	h3 {
		color: #ea747f;
	}
}
</style>
